import { Component, ChangeDetectionStrategy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

import { roundTo } from "round-to";
import { PrintLayoutService } from "src/app/components/print-layout/print-layout.service";
import { User } from "src/app/core/models/user.model";
import { AuthService } from "src/app/core/services/auth.service";
import { CustomerType } from "src/app/models/customer";
import { Invoice } from "src/app/models/invoice";
import { Payment, PaymentMode } from "src/app/models/payment";
import { Tax } from "src/app/models/tax";
import { fadeInOut } from "src/app/services/animations";
import { EntityDataSourceCustomBindReport } from "src/app/services/entity.datasource";
import { SalesLineService } from "src/app/services/salesLine.service";

@Component({
  selector: "app-print-pos-invoice",
  templateUrl: "./print-pos-invoice.component.html",
  styleUrls: ["./print-pos-invoice.component.scss"],
  animations: [fadeInOut],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrintPosInvoiceComponent implements OnInit {
  displayedColumnsSOLine: string[] = ["description", "qty", "rate", "amount"];

  id: number;
  invoice: Invoice;
  payment: Payment;
  tax: Tax;

  dataSourceSOLine: any[] = [];
  dataSource: EntityDataSourceCustomBindReport;
  readonly endpointUrl = "/api/salesLines/GetSalesLineView";
  lineCount: number;
  applicationUser: User;

  constructor(
    private printLayoutService: PrintLayoutService,
    private salesLineService: SalesLineService,
    private route: ActivatedRoute,
    private authService: AuthService
  ) {
    this.applicationUser = this.authService.currentUser;

    this.id = Number(this.route.snapshot.paramMap.get("id"));
    this.route.data.subscribe(({ invoice }) => {
      if (invoice) {
        this.invoice = invoice;

        this.invoice.paymentInvoiceMaps.forEach((x) => {
          this.payment = x.payment;
        });
      }
    });

    this.route.data.subscribe(({ tax }) => {
      if (tax) {
        this.tax = tax;
      }
    });
  }

  ngOnInit() {
    this.dataSource = new EntityDataSourceCustomBindReport(
      this.salesLineService,
      this.endpointUrl
    );
    this.dataSource.loadReport(
      this.invoice.salesId,
      this.displayedColumnsSOLine
    );
    this.dataSource.entityCount$.subscribe((c) => (this.lineCount = c));
    this.dataSource.currentData$.subscribe((rows) => {
      this.dataSourceSOLine = rows;
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.printLayoutService.onDataReady();
    }, 1000);
  }

  getCustomerType(value: number) {
    return CustomerType[value];
  }
  getPaymentMode(value: number) {
    return PaymentMode[value];
  }
}
